/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge,ShimmerButton,ShimmerTitle,ShimmerThumbnail, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'

function ProductSkeleton() {
    return (
        <>{[...Array(10)].map((prod,i)=>(
            <div className={`${i!==0?'pt-[18px]':''}`} key={`${prod}`}>
                <div className="rounded-lg bg-[#FFFFFF] shadow-s7 pt-2 sm:pb-2.5 pb-2 sm:pl-3 sm:pr-4 px-2.5 relative">
                    <div className="flex flex-wrap">
                        <div className="lg:w-[65%] w-full pt-2">
                            <div className="flex">
                                <div className="w-1/4">
                                    <ShimmerThumbnail height={80} className="cursor-pointer w-3.5 h-3.5" />
                                </div>
                                <div className="pl-2.5">
                                    <div>
                                        <p className="sm:text-xl text-base font-bold text-[#090406] pr-3"><ShimmerTitle line={1} gap={10} variant="primary" />{/* <span className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit ml-2.5"><ShimmerBadge/></span> */}</p>
                                    </div>
                                    <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1"><ShimmerBadge width={250}/></p>
                                    <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                        <div className="flex sm:pr-2.5 w-fit items-center">
                                            <p className="text-xs font-semibold text-[090406]">{<ShimmerBadge width={70}/>}</p>
                                            <p className="text-xs3 font-semibold text-white px-1 rounded-[3px] w-fit mx-1.5"><ShimmerBadge /></p>
                                            <ShimmerCircularImage size={10}/>
                                        </div>
                                        <p className="text-xs font-semibold text-[#808285] sm:px-2 sm:pt-0 pt-1"><ShimmerBadge/>: <span className="font-bold text-[#555259]">{<ShimmerBadge />}</span></p>
                                        {/* <p className="text-xs font-semibold text-[#808285] sm:pl-2 sm:pt-0 pt-1">Expected Delivery: <span className="font-bold text-[#555259]">24/06/2022</span></p> */}
                                    </div>
                                    <p className="text-xs font-semibold text-[#808285] sm:mt-2 mt-1"><ShimmerBadge/> <span className="text-[#555259]">{<ShimmerBadge />}</span></p>
                                </div>
                            </div> 
                            <div className="lg:w-[70%] w-full sm:pl-4">
                                <ShimmerText line={2} gap={10} variant="primary" />
                            </div>
                        </div>
                        <div className="lg:w-[35%] w-full lg:pt-0 pt-5">
                            <div className="flex justify-end w-full lg:pr-10 pr-0">
                                <p><ShimmerButton size="sm"/></p>
                            </div>
                            <div>
                                <div className="bg-[#EAEAF0] rounded-md p-4 w-full mt-1.5">
                                    {[...Array(2)].map((item)=>(
                                        <div className="flex" key={item}>
                                            <div className="w-1/2 pr-1">
                                                <p className="text-xs font-semibold text-[#616874]"><ShimmerBadge width={120}/></p>
                                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]"><ShimmerBadge width={120}/></p>
                                            </div>
                                            <div className="w-1/2 pr-1">
                                                <p className="text-xs font-semibold text-[#616874]"><ShimmerBadge width={120}/></p>
                                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]"><ShimmerBadge width={120}/></p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-center">
                        <div className="lg:w-[65%] w-full pl-4">
                            <p className="sm:text-xs6 text-xs2 font-semibold text-[#808285]"><ShimmerBadge /></p>
                            <p className="md:text-xs11 sm:text-xl text-lg font-semibold text-[#15090E]"><ShimmerBadge /></p>
                        </div>
                        <div className="lg:w-[35%] w-full flex justify-center">
                            <ShimmerButton size="sm" width={300}/>
                        </div>
                    </div>
                    <button type="button" data-bs-toggle="modal" data-bs-target="#addtoWishlistmodal">
                        <ShimmerCircularImage size={30} className="absolute top-4 right-[22px] cursor-pointer" />
                    </button>
                </div>
            </div>
        ))}</>
    )
}

export default ProductSkeleton